import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { history } from 'containers/App';
import { ApiService } from 'services';
import { PropTypes } from 'prop-types';

const KeepAlive = ({ unprotectedRoutes }) => {
  const keepAliveUrl = useSelector(state => state.app.onlineConfig?.keepAliveUrl || null);

  const cacheBuster = useSelector(() => {
    const timestamp = new Date().getTime();
    const twentySecondInterval = Math.round(timestamp / 20_000);
    return twentySecondInterval;
  });

  useEffect(() => {
    if (!unprotectedRoutes.includes(window.location.pathname)) {
      ApiService.getAuthState()
        .then((a) => {
          if (a?.data?.authState !== 'Authorised') {
            history.push('/sessiontimeout');
          }
        })
        .catch((e) => {
          // unable to extend session
        });
    }
  }, [cacheBuster]);

  return (
    <React.Fragment>
      { keepAliveUrl && <img className="keepalive" height="0" alt="keep alive" src={ `${ keepAliveUrl }?timestamp=${ cacheBuster }` } /> }
    </React.Fragment>
  );
};

KeepAlive.propTypes = {
  unprotectedRoutes: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default KeepAlive;
